<template>
  <div>
    <common-table :table-columns="tableColumns" :url="url" :operate="[]" :searchs="searchs" :form-fields="formFields"
                  :permission="permission"/>
  </div>
</template>

<script>
import CommonTable from "@/components/CommonTable/CommonTable.vue";

export default {
  name: 'UntrustedDomain',
  components: {CommonTable},
  data() {
    return {
      searchs: [{
        name: 'agentId',
        placeholder: '代理',
        type: 'select',
        selectUrl: '/agent/getAll',
        selectData: [],
      }],
      permission: {
        add: 'untrustedDomain:add',
        update: 'untrustedDomain:update',
        delete: 'untrustedDomain:delete',
        deleteBatch: 'untrustedDomain:deleteBatch'
      },
      url: {
        get: '/untrustedDomain/listByCondition',
        add: '/untrustedDomain/add',
        update: '/untrustedDomain/update',
        delete: '/untrustedDomain/delete',
        delete_batch: '/untrustedDomain/deleteBatch',
        status: '/untrustedDomain/status',
      },
      tableColumns: [{
        field: 'id',
        label: 'Id',
        show: true,
        width: '100',
      },
        {
          field: 'domain',  // 字段名
          label: '域名',  // 字段显示名称
          sort: false,  // 是否排序
          show: true,  // 是否展示
        }, {
          field: 'status',  // 字段名
          label: '状态',  // 字段显示名称
          sort: false,  // 是否排序
          show: true,  // 是否展示
          status: true,
        },
        {
          field: 'createTime',
          label: '创建时间',
          show: true,
          width: '',
        }

      ],
      formFields: {
        addTitle: '添加',
        updateTitle: '修改',
        model: [
          {
            field: 'id',  // 字段名
            label: 'ID',  // 字段显示名称
            type: 'input',
            add: false,  // 是否添加
            update: true
          },
          {
            field: 'domain',  // 字段名
            label: 'domain',  // 字段显示名称
            type: 'input',
            placeholder: '请输入domain',
            rules: [
              {required: true, message: 'domain不能为空', trigger: 'blur'}
            ],
            add: true,
            update: true,
          }, {
            field: 'status',  // 字段名
            label: 'status',  // 字段显示名称
            type: 'input',
            placeholder: '请输入status',
            rules: [
              {required: true, message: 'status不能为空', trigger: 'blur'}
            ],
            add: true,
            update: true,
          },
        ]
      },
      operate: []
    }
  }
}
</script>

<style scoped>

</style>
